import Vue from 'vue'
import Router from 'vue-router'
import login from '@/components/login'
import test from '@/components/test'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'login',
      component: login,
        // component: () => import('@/components/login'),
    },
    {
      path: '/test',
      name: 'test',
      component: test,
      // component: () => import('@/components/test'),
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js